export const LOCALES = ['en', 'es'];
export const PHONE_MIN_LENGTH = 14;

export const US_STATES: { name: string; abbreviation: string; slug: string }[] = [
  { name: 'Alabama', abbreviation: 'AL', slug: 'alabama' },
  { name: 'Alaska', abbreviation: 'AK', slug: 'alaska' },
  { name: 'Arizona', abbreviation: 'AZ', slug: 'arizona' },
  { name: 'Arkansas', abbreviation: 'AR', slug: 'arkansas' },
  { name: 'California', abbreviation: 'CA', slug: 'california' },
  { name: 'Colorado', abbreviation: 'CO', slug: 'colorado' },
  { name: 'Connecticut', abbreviation: 'CT', slug: 'connecticut' },
  { name: 'Delaware', abbreviation: 'DE', slug: 'delaware' },
  { name: 'Florida', abbreviation: 'FL', slug: 'florida' },
  { name: 'Georgia', abbreviation: 'GA', slug: 'georgia' },
  { name: 'Hawaii', abbreviation: 'HI', slug: 'hawaii' },
  { name: 'Idaho', abbreviation: 'ID', slug: 'idaho' },
  { name: 'Illinois', abbreviation: 'IL', slug: 'illinois' },
  { name: 'Indiana', abbreviation: 'IN', slug: 'indiana' },
  { name: 'Iowa', abbreviation: 'IA', slug: 'iowa' },
  { name: 'Kansas', abbreviation: 'KS', slug: 'kansas' },
  { name: 'Kentucky', abbreviation: 'KY', slug: 'kentucky' },
  { name: 'Louisiana', abbreviation: 'LA', slug: 'louisiana' },
  { name: 'Maine', abbreviation: 'ME', slug: 'maine' },
  { name: 'Maryland', abbreviation: 'MD', slug: 'maryland' },
  { name: 'Massachusetts', abbreviation: 'MA', slug: 'massachusetts' },
  { name: 'Michigan', abbreviation: 'MI', slug: 'michigan' },
  { name: 'Minnesota', abbreviation: 'MN', slug: 'minnesota' },
  { name: 'Mississippi', abbreviation: 'MS', slug: 'mississippi' },
  { name: 'Missouri', abbreviation: 'MO', slug: 'missouri' },
  { name: 'Montana', abbreviation: 'MT', slug: 'montana' },
  { name: 'Nebraska', abbreviation: 'NE', slug: 'nebraska' },
  { name: 'Nevada', abbreviation: 'NV', slug: 'nevada' },
  { name: 'New Hampshire', abbreviation: 'NH', slug: 'new-hampshire' },
  { name: 'New Jersey', abbreviation: 'NJ', slug: 'new-jersey' },
  { name: 'New Mexico', abbreviation: 'NM', slug: 'new-mexico' },
  { name: 'New York', abbreviation: 'NY', slug: 'new-yok' },
  { name: 'North Carolina', abbreviation: 'NC', slug: 'north-carolina' },
  { name: 'North Dakota', abbreviation: 'ND', slug: 'north-dakota' },
  { name: 'Ohio', abbreviation: 'OH', slug: 'ohio' },
  { name: 'Oklahoma', abbreviation: 'OK', slug: 'oklahoma' },
  { name: 'Oregon', abbreviation: 'OR', slug: 'oregon' },
  { name: 'Pennsylvania', abbreviation: 'PA', slug: 'pennsylvania' },
  { name: 'Rhode Island', abbreviation: 'RI', slug: 'rhode-island' },
  { name: 'South Carolina', abbreviation: 'SC', slug: 'south-carolina' },
  { name: 'South Dakota', abbreviation: 'SD', slug: 'south-dakota' },
  { name: 'Tennessee', abbreviation: 'TN', slug: 'tennessee' },
  { name: 'Texas', abbreviation: 'TX', slug: 'texas' },
  { name: 'Utah', abbreviation: 'UT', slug: 'utah' },
  { name: 'Vermont', abbreviation: 'VT', slug: 'vermont' },
  { name: 'Virginia', abbreviation: 'VA', slug: 'virginia' },
  { name: 'Washington', abbreviation: 'WA', slug: 'washington' },
  { name: 'West Virginia', abbreviation: 'WV', slug: 'west-virginia' },
  { name: 'Wisconsin', abbreviation: 'WI', slug: 'wisconsin' },
  { name: 'Wyoming', abbreviation: 'WY', slug: 'wyoming' },
];

export const US_STATES_ABBREVIATIONS = US_STATES.map((state) => state.abbreviation);
export const US_STATES_NAMES = US_STATES.map((state) => state.name);

export const findStateBySlug = (slug: string) => US_STATES.find((s) => s.slug === slug);

export const findStateByName = (name: string) =>
  US_STATES.find((s) => s.name.toLowerCase() === name.toLowerCase());

export type StateType = { name: string; abbreviation: string; slug: string };

export const ContentType = {
  AboutUs: 'About Us',
  Article: 'Article',
  FAQ: 'FAQ',
  CaseResults: 'Case Results',
  AccidentTypes: 'Accident Types',
  InjuryTypes: 'Injury Types',
  Injury: 'Injury',
  PracticeAreas: 'Practice Areas',
  ProcessSteps: 'Process Steps',
  ReasonsToChooseUs: 'Reasons to Choose Us',
  RecoveryExpertise: 'Recovery Expertise',
  Testimonials: 'Testimonials',
  ThingsToKnowAbout: 'Things to Know About',
  WaysToHelp: 'Ways to Help',
} as const;

export const QUESTION_TYPE_WITH_OPTIONS_LABELS = {
  labeled_single_option: 'Single Option',
  labeled_multiple_options: 'Multiple Options',
  dropdown_single_option: 'Dropdown Single Option',
  dropdown_multiple_options: 'Dropdown Multiple Options',
};

export const QUESTION_TYPE_LABELS = {
  short_text: 'Short Text',
  long_text: 'Long Text',
  boolean: 'Yes/No',
  address: 'Address',
  phone: 'Phone Number',
  email: 'Email Address',
  date: 'Date',
  ...QUESTION_TYPE_WITH_OPTIONS_LABELS,
};

export const TYPES_WITH_OPTIONS = Object.keys(QUESTION_TYPE_WITH_OPTIONS_LABELS);

export const QUESTION_TYPES = Object.keys(QUESTION_TYPE_LABELS);

export const PageTypes = {
  RootLevel: 'root-level',
  GeneralContent: 'general-content',
  Location: 'location',
  ClaimType: 'claim-type',
  ClamSection: 'claim-section',
} as const;
